import debounce from 'lodash/debounce';

export default {
  data() {
    return {
      show: false,
      isMobile: this.isMobileCheck(),
    };
  },
  created() {
    window.addEventListener('resize', debounce(this.isMobileHandler), 500);
  },
  beforeDestory() {
    window.removeEventListener('resize', debounce(this.isMobileHandler), 500);
  },
  methods: {
    isMobileHandler() {
      if (this.isMobileCheck()) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
    },
    isMobileCheck() {
      return window.outerWidth < 768;
    },
  },
};
